import FormElementMixin from '../mixins/FormElementMixin.js';

Vue.asyncComponent('ak-checkboxes', {
    mixins: [FormElementMixin],
    props: {
        selectOptions: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            selected: []
        }
    },
    watch: {
        selected() {
            this.$emit('input', this.selected);
        }
    },
}, 'form/controls/ak-checkboxes.html');